import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-bold transition-colors",
  {
    variants: {
      variant: {
        default: "bg-white/70 text-slate-700 border border-slate-200/80 backdrop-blur-md",
        green: "bg-emerald-500/12 text-emerald-700 border border-emerald-500/20",
        lime: "bg-floodlight text-ink",
        dark: "bg-white/10 text-white backdrop-blur-md border border-white/15",
        navy: "bg-ink text-white",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

export default function Badge({ className, variant, ...props }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}
